export default "query getCourseLearningCount($courseId: String!) {\n  getCourseLearningCount(courseId: $courseId) \n}";